export enum AccountTypes {
  EMPTY = '',
  ESTATE = 'ESTATE',
  EXECUTOR_ESTATE = 'EXECUTOR_ESTATE',
  INDIVIDUAL = 'INDIVIDUAL',
  INDV = 'INDV',
  IRA = 'IRA',
  JOINT = 'JOINT',
  JOINT_COMMUNITY_PROPERTY = 'JOINT_COMMUNITY_PROPERTY',
  JOINT_TENANTS_WROS = 'JOINT_TENANTS_WROS',
  ORG = 'ORG',
  OTHER = 'OTHER',
  TRUST = 'TRUST',
  UGMA_UTMA = 'UGMA_UTMA',
}

export enum AccountTypeNames {
  EMPTY = '',
  EXECUTOR_ESTATE = 'Estate',
  ESTATE = 'Estate',
  INDIVIDUAL = 'Individual',
  INDV = 'Individual',
  IRA = 'IRA',
  JOINT = 'Joint',
  JOINT_TENANTS_WROS = 'Joint',
  ORG = 'Organization',
  OTHER = 'Other',
  TRUST = 'Trust',
  UGMA_UTMA = 'UGMA/UTMA',
}
